(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('debug'), require('penpal'), require('eventemitter3'), require('axios'), require('ethers'), require('@play-co/svs-signer-validator'), require('@metamask/detect-provider')) :
	typeof define === 'function' && define.amd ? define(['exports', 'debug', 'penpal', 'eventemitter3', 'axios', 'ethers', '@play-co/svs-signer-validator', '@metamask/detect-provider'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.SvsNavbar = {}, global.debug, global.penpal, global.EventEmitter, global.axios, global.ethers, global.svsSignerValidator, global.detectEthereumProvider));
})(this, (function (exports, debug, penpal, EventEmitter, axios, ethers, svsSignerValidator, detectEthereumProvider) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);
	var EventEmitter__default = /*#__PURE__*/_interopDefaultLegacy(EventEmitter);
	var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
	var detectEthereumProvider__default = /*#__PURE__*/_interopDefaultLegacy(detectEthereumProvider);

	function getAugmentedNamespace(n) {
	  var f = n.default;
		if (typeof f == "function") {
			var a = function () {
				return f.apply(this, arguments);
			};
			a.prototype = f.prototype;
	  } else a = {};
	  Object.defineProperty(a, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	var lib = {};

	/******************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};

	function __extends(d, b) {
	    if (typeof b !== "function" && b !== null)
	        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};

	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}

	function __decorate(decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	}

	function __param(paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	}

	function __metadata(metadataKey, metadataValue) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	}

	function __awaiter(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}

	function __generator(thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	}

	var __createBinding = Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	        desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	});

	function __exportStar(m, o) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	}

	function __values(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}

	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}

	/** @deprecated */
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}

	/** @deprecated */
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}

	function __spreadArray(to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	}

	function __await(v) {
	    return this instanceof __await ? (this.v = v, this) : new __await(v);
	}

	function __asyncGenerator(thisArg, _arguments, generator) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var g = generator.apply(thisArg, _arguments || []), i, q = [];
	    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	    function fulfill(value) { resume("next", value); }
	    function reject(value) { resume("throw", value); }
	    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	}

	function __asyncDelegator(o) {
	    var i, p;
	    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	}

	function __asyncValues(o) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var m = o[Symbol.asyncIterator], i;
	    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	}

	function __makeTemplateObject(cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	}
	var __setModuleDefault = Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	};

	function __importStar(mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	}

	function __importDefault(mod) {
	    return (mod && mod.__esModule) ? mod : { default: mod };
	}

	function __classPrivateFieldGet(receiver, state, kind, f) {
	    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	}

	function __classPrivateFieldSet(receiver, state, value, kind, f) {
	    if (kind === "m") throw new TypeError("Private method is not writable");
	    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	}

	function __classPrivateFieldIn(state, receiver) {
	    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	    return typeof state === "function" ? receiver === state : state.has(receiver);
	}

	var tslib_es6 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		__extends: __extends,
		get __assign () { return __assign; },
		__rest: __rest,
		__decorate: __decorate,
		__param: __param,
		__metadata: __metadata,
		__awaiter: __awaiter,
		__generator: __generator,
		__createBinding: __createBinding,
		__exportStar: __exportStar,
		__values: __values,
		__read: __read,
		__spread: __spread,
		__spreadArrays: __spreadArrays,
		__spreadArray: __spreadArray,
		__await: __await,
		__asyncGenerator: __asyncGenerator,
		__asyncDelegator: __asyncDelegator,
		__asyncValues: __asyncValues,
		__makeTemplateObject: __makeTemplateObject,
		__importStar: __importStar,
		__importDefault: __importDefault,
		__classPrivateFieldGet: __classPrivateFieldGet,
		__classPrivateFieldSet: __classPrivateFieldSet,
		__classPrivateFieldIn: __classPrivateFieldIn
	});

	var require$$0 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

	var ConditionWaiter$1 = {};

	Object.defineProperty(ConditionWaiter$1, "__esModule", { value: true });
	ConditionWaiter$1.ConditionWaiter = void 0;
	function defaultCondition(value) {
	    return !!value;
	}
	class ConditionWaiter {
	    constructor(initialValue, condition) {
	        this.value = undefined;
	        this.resolves = [];
	        if (!condition) {
	            condition = defaultCondition;
	        }
	        this.value = initialValue;
	        this.condition = condition;
	    }
	    checkAndMaybeResolve() {
	        if (this.resolves.length === 0) {
	            return;
	        }
	        if (!this.condition(this.value)) {
	            return;
	        }
	        this.resolves.forEach((resolve) => resolve(this.value));
	        this.resolves = [];
	    }
	    setCondition(condition) {
	        this.condition = condition;
	    }
	    set(value) {
	        this.value = value;
	        this.checkAndMaybeResolve();
	    }
	    get() {
	        return this.value;
	    }
	    wait() {
	        if (this.condition(this.value)) {
	            return Promise.resolve(this.value);
	        }
	        return new Promise((resolve) => this.resolves.push(resolve));
	    }
	}
	ConditionWaiter$1.ConditionWaiter = ConditionWaiter;

	var NumberUtils = {};

	var hasRequiredNumberUtils;

	function requireNumberUtils () {
		if (hasRequiredNumberUtils) return NumberUtils;
		hasRequiredNumberUtils = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			exports.clamp = exports.daysToMs = exports.hoursToMs = exports.minutesToMs = exports.secondsToMs = exports.msToDays = exports.msToHours = exports.msToMinutes = exports.msToSeconds = exports.dayInMs = exports.hourInMs = exports.minuteInMs = exports.secondInMs = void 0;
			exports.secondInMs = 1000;
			exports.minuteInMs = 60 * 1000;
			exports.hourInMs = 60 * 60 * 1000;
			exports.dayInMs = 24 * 60 * 60 * 1000;
			function msToSeconds(ms) {
			    return ms / exports.secondInMs;
			}
			exports.msToSeconds = msToSeconds;
			function msToMinutes(ms) {
			    return ms / exports.minuteInMs;
			}
			exports.msToMinutes = msToMinutes;
			function msToHours(ms) {
			    return ms / exports.hourInMs;
			}
			exports.msToHours = msToHours;
			function msToDays(ms) {
			    return ms / exports.dayInMs;
			}
			exports.msToDays = msToDays;
			function secondsToMs(seconds) {
			    return seconds * exports.secondInMs;
			}
			exports.secondsToMs = secondsToMs;
			function minutesToMs(minutes) {
			    return minutes * exports.minuteInMs;
			}
			exports.minutesToMs = minutesToMs;
			function hoursToMs(hours) {
			    return hours * exports.hourInMs;
			}
			exports.hoursToMs = hoursToMs;
			function daysToMs(days) {
			    return days * exports.dayInMs;
			}
			exports.daysToMs = daysToMs;
			function clamp(value, min, max) {
			    return value < min ? min : value > max ? max : value;
			}
			exports.clamp = clamp;
			
	} (NumberUtils));
		return NumberUtils;
	}

	var Plot = {};

	var hasRequiredPlot;

	function requirePlot () {
		if (hasRequiredPlot) return Plot;
		hasRequiredPlot = 1;
		Object.defineProperty(Plot, "__esModule", { value: true });
		
		return Plot;
	}

	var WaitUtils = {};

	Object.defineProperty(WaitUtils, "__esModule", { value: true });
	WaitUtils.waitForSeconds = waitForMs_1 = WaitUtils.waitForMs = void 0;
	function waitForMs(ms) {
	    return new Promise(resolve => setTimeout(resolve, ms));
	}
	var waitForMs_1 = WaitUtils.waitForMs = waitForMs;
	function waitForSeconds(seconds) {
	    return waitForMs(seconds * 1000);
	}
	WaitUtils.waitForSeconds = waitForSeconds;

	var SvsNavbarEvent = {};

	var hasRequiredSvsNavbarEvent;

	function requireSvsNavbarEvent () {
		if (hasRequiredSvsNavbarEvent) return SvsNavbarEvent;
		hasRequiredSvsNavbarEvent = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			exports.SvsNavbarEvent = void 0;
			(function (SvsNavbarEvent) {
			    SvsNavbarEvent["Any"] = "any";
			    SvsNavbarEvent["LoginStateChanged"] = "loginstatechanged";
			    SvsNavbarEvent["WalletChanged"] = "walletchanged";
			    SvsNavbarEvent["RefreshIframeRequested"] = "refreshiframerequested";
			})(exports.SvsNavbarEvent || (exports.SvsNavbarEvent = {}));
			
	} (SvsNavbarEvent));
		return SvsNavbarEvent;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.SvsNavbarEvent = exports.WaitUtils = exports.NumberUtils = exports.ConditionWaiter = void 0;
		const tslib_1 = require$$0;
		var ConditionWaiter_1 = ConditionWaiter$1;
		Object.defineProperty(exports, "ConditionWaiter", { enumerable: true, get: function () { return ConditionWaiter_1.ConditionWaiter; } });
		exports.NumberUtils = tslib_1.__importStar(requireNumberUtils());
		tslib_1.__exportStar(requirePlot(), exports);
		exports.WaitUtils = tslib_1.__importStar(WaitUtils);
		var SvsNavbarEvent_1 = requireSvsNavbarEvent();
		Object.defineProperty(exports, "SvsNavbarEvent", { enumerable: true, get: function () { return SvsNavbarEvent_1.SvsNavbarEvent; } });
		
	} (lib));

	async function fetchNFTs(serviceProxyUrl, walletAddress, contractAddress) {
	    var _a, _b;
	    const url = `${serviceProxyUrl}/a/getNFTsFiltered/${walletAddress.toLowerCase()}/${contractAddress}`;
	    try {
	        const response = await axios__default["default"].get(url);
	        return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
	    }
	    catch (e) {
	        console.warn('fetching failed:', e);
	        return [];
	    }
	}
	class WalletReader {
	    constructor(env) {
	        this.env = env;
	    }
	    // get NFT owned in a wallet address
	    async getNfts(walletAddress, contractAddress) {
	        // https://docs.alchemy.com/alchemy/enhanced-apis/nft-api/getnfts
	        // ouput:
	        // [
	        //     {
	        //       contract: { address: '0x3d666422ffd721e3999395c2a25dc880d785a72a' },
	        //       id: {
	        //         tokenId: '0x0000000000000000000000000000000000000000000000000000000000001bbc'
	        //       },
	        //       balance: '1'
	        //     },
	        //     {
	        //       contract: { address: '0xe521a3419f78cbdef2c5baad4835bcdddd2504f8' },
	        //       id: {
	        //         tokenId: '0x00000000000000000000000000000000000000000000000000000000000003e3'
	        //       },
	        //       balance: '1'
	        //     },
	        // make a call to svs-metadata endpoint which should handle pagination and return complete result
	        const nfts = await fetchNFTs(this.env.serviceProxyUrl, walletAddress, contractAddress);
	        let retval = {};
	        for (const tokenData of nfts) {
	            const contractAddress = tokenData.contract.address;
	            const tokenId = tokenData.id.tokenId;
	            // Note that Alchemy getNfts API return hex string for tokenId
	            // following line is to convert the hex to decimal
	            const fixedTokenId = ethers.ethers.BigNumber.from(tokenId).toString(); // hex to base-10
	            if (!retval[contractAddress]) {
	                retval[contractAddress] = [];
	            }
	            retval[contractAddress].push(fixedTokenId);
	        }
	        // sample output
	        // {
	        //     '0x3d666422ffd721e3999395c2a25dc880d785a72a': [
	        //       '123'
	        //     ],
	        //     '0xe521a3419f78cbdef2c5baad4835bcdddd2504f8': [
	        //       '456',
	        //       '678'
	        //     ]
	        //   }
	        return retval;
	    }
	    async getNftsInfoForWallet(walletAddress, contractAddress) {
	        let contractsToTokens = {};
	        let numTokens = 0;
	        const contractToTokenIds = await this.getNfts(walletAddress, contractAddress);
	        for (const [contract, tokenIds] of Object.entries(contractToTokenIds)) {
	            // these two lines get replaced by calls to Tenv.plotsBaseURI/tokenid
	            // const contractReader = ContractReaderWrapper.getReader(contract, this.env)
	            // contractsToTokens[contract] = await contractReader.readContract(contract, tokenIds)
	            const contractObj = {
	                address: contract,
	                name: 'PLOT',
	                baseURI: this.env.plotsBaseURI,
	                tokens: {},
	            };
	            // fetch all NFTs data parallely to save time
	            await Promise.all(tokenIds.map((tokenId) => this.getMetadataFromBaseUri(contractObj.baseURI, tokenId).then((tokenObject) => {
	                contractObj.tokens[tokenId] = tokenObject;
	            })));
	            contractsToTokens[contract] = contractObj;
	            numTokens = numTokens + tokenIds.length;
	        }
	        return {
	            contracts: contractsToTokens,
	            numTokens: numTokens,
	            numContracts: Object.keys(contractsToTokens).length,
	        };
	    }
	    async getMetadataFromBaseUri(baseUri, tokenId) {
	        if (baseUri.length <= 0) {
	            throw new Error('trying to retrive information from empty baseUri, this is bad...');
	        }
	        try {
	            const getNFTMetadataResult = await axios__default["default"].get(`${baseUri}/${tokenId}`);
	            return getNFTMetadataResult.data;
	        }
	        catch (err) {
	            console.error('getMetadataFromBaseUri failed: ' + baseUri + tokenId);
	            return {};
	        }
	    }
	    echo(text) {
	        return text;
	    }
	}

	var HttpMethod;
	(function (HttpMethod) {
	    HttpMethod["Get"] = "GET";
	    HttpMethod["Post"] = "POST";
	})(HttpMethod || (HttpMethod = {}));
	var EndPoint;
	(function (EndPoint) {
	    EndPoint["CurrentContractAddress"] = "/chains/ethereum/addresses/storyverse_plot";
	})(EndPoint || (EndPoint = {}));
	const log$3 = debug__default["default"]('svsnavbar:mbaasservice');
	class MBaasResponseError extends Error {
	    constructor(request, response, status, ...args) {
	        super(...args);
	        this.request = request;
	        this.response = response;
	        this.status = status;
	        this.isResponseError = true;
	    }
	}
	async function mBaasFetch(config, method, path, args = []) {
	    const req = {
	        method,
	        headers: {
	            Authorization: 'Bearer ' + config.mBaasApiKey,
	            'Content-Type': 'application/json',
	        },
	        credentials: 'include',
	    };
	    if (method === 'POST') {
	        req.body = JSON.stringify({ args });
	    }
	    const response = await fetch(config.mBaasBaseUrl + path, req);
	    if (!response.ok) {
	        let message = '';
	        let data;
	        try {
	            data = await response.json();
	        }
	        catch (e) {
	            // probably not json
	            data = null;
	        }
	        if (!data) {
	            try {
	                message = await response.text();
	            }
	            catch (e) {
	                message = ': Unknown (parse error)';
	            }
	        }
	        const errorReq = Object.assign({ url: response.url }, req);
	        throw new MBaasResponseError(errorReq, { message, data }, response.status, `Fetch error (status ${response.status})${message}`);
	    }
	    const obj = await response.json();
	    return obj;
	}
	class MBaasService {
	    constructor(opts) {
	        this.opts = opts;
	    }
	    async fetchCurrentContractAddress() {
	        var _a, _b;
	        try {
	            const response = await mBaasFetch(this.opts, HttpMethod.Get, EndPoint.CurrentContractAddress);
	            return (_b = (_a = response.result) === null || _a === void 0 ? void 0 : _a.address) !== null && _b !== void 0 ? _b : undefined;
	        }
	        catch (e) {
	            log$3('Error occurred while fetching address:', e);
	            return undefined;
	        }
	    }
	}

	const log$2 = debug__default["default"]('svsnavbar:walletservice');
	var ServiceEndpoint;
	(function (ServiceEndpoint) {
	    ServiceEndpoint["PocAuthChoiceCreation"] = "/poc/authorizeChoiceCreation";
	    ServiceEndpoint["PocAuthOptionMinting"] = "/poc/authorizeOptionMinting";
	})(ServiceEndpoint || (ServiceEndpoint = {}));
	function loginStateFinished(loginState) {
	    switch (loginState) {
	        case 2 /* LoginState.LoggedIn */:
	        case 4 /* LoginState.LoggedOut */:
	        case 5 /* LoginState.Errored */:
	            return true;
	        default:
	            return false;
	    }
	}
	class MetaMaskWalletService extends EventEmitter__default["default"] {
	    constructor() {
	        super();
	        this.loggedInWaiter = new lib.ConditionWaiter(false);
	        this.inittedWaiter = new lib.ConditionWaiter(false);
	        this.providerWaiter = new lib.ConditionWaiter(null);
	        this.loginStateWaiter = new lib.ConditionWaiter(0 /* LoginState.Idle */, loginStateFinished);
	        this.address = null;
	        this.signer = null;
	        this.ethListenersAttached = false;
	        this.plots = null;
	        this.serviceAxios = null;
	        this.tokenIdToSaveCount = {};
	        this.onEthChainChanged = this.onEthChainChanged.bind(this);
	        this.onEthAccountsChanged = this.onEthAccountsChanged.bind(this);
	    }
	    get loggedIn() {
	        return this.loggedInWaiter.get();
	    }
	    get initted() {
	        return this.inittedWaiter.get();
	    }
	    async init(opts) {
	        if (this.initted) {
	            return;
	        }
	        // reason for following lines: we may call init() without opts, after first init(opts)
	        if (opts) {
	            this.opts = opts;
	            this.walletReader = new WalletReader(opts);
	            this.mBaasService = new MBaasService(opts);
	            this.persistDraftServerPrefix = this.opts.persistDraftServerPrefix;
	            this.persistPlotServerPrefix = this.opts.persistPlotServerPrefix;
	            this.serviceAxios = axios__default["default"].create({
	                baseURL: this.opts.serviceProxyUrl,
	                validateStatus: () => true, // let client deal with errors
	            });
	        }
	        if (!this.opts) {
	            throw new Error('Empty Opts');
	        }
	        const baseProvider = await detectEthereumProvider__default["default"]();
	        log$2('Initting...');
	        if (!this.provider && baseProvider) {
	            const provider = new ethers.ethers.providers.Web3Provider(baseProvider);
	            this.providerWaiter.set(provider);
	            if (!this.ethListenersAttached) {
	                baseProvider.on('chainChanged', this.onEthChainChanged);
	                baseProvider.on('accountsChanged', this.onEthAccountsChanged);
	                this.ethListenersAttached = true;
	            }
	        }
	        await this.checkForLoggedIn();
	        this.inittedWaiter.set(true);
	        log$2('Initted.');
	    }
	    waitForInit() {
	        return this.inittedWaiter.wait();
	    }
	    signUp() {
	        return this.logIn();
	    }
	    async logIn() {
	        await this.startLogin();
	        return this.loggedIn;
	    }
	    logOut() {
	        // shouldn't really be used
	        return this.startLogout();
	    }
	    async getWallet(force = false) {
	        var _a;
	        await this.init();
	        if (!this.loggedIn) {
	            log$2('getWallet: Not logged in');
	            const wallet = { loggedIn: false };
	            this.emit(lib.SvsNavbarEvent.WalletChanged, wallet);
	            return wallet;
	        }
	        if (!this.plots || force) {
	            log$2('getWallet: Fetching current contract address...');
	            const contractAddr = await this.mBaasService.fetchCurrentContractAddress();
	            // TODO better way to handle undefined address?
	            if (contractAddr) {
	                const contractAddrLC = contractAddr.toLowerCase();
	                log$2('getWallet: Fetching NFTs...');
	                const wallet = await this.walletReader.getNftsInfoForWallet(this.address, contractAddrLC);
	                log$2('getWallet: Wallet has', wallet.numTokens, 'tokens');
	                if (wallet.numTokens <= 0) {
	                    // stop here because if no token after filter, the contracts fields are also empty.
	                    this.plots = [];
	                }
	                else {
	                    this.plots = Object.values(wallet.contracts[contractAddrLC].tokens);
	                }
	            }
	            else {
	                log$2('getWallet: No contract address found');
	            }
	        }
	        log$2('getWallet: Logged in');
	        const wallet = {
	            loggedIn: true,
	            address: this.address,
	            plots: (_a = this.plots) !== null && _a !== void 0 ? _a : [],
	            messageAndSig: this.checkStoredSignedMessageAndSignature(this.address),
	        };
	        this.emit(lib.SvsNavbarEvent.WalletChanged, wallet);
	        return wallet;
	    }
	    async saveDraft(tokenId, data, force = false) {
	        log$2('saveDraft: ', tokenId);
	        if (!(await this.logIn())) {
	            log$2('saveDraft: could not save because log in failed');
	            return undefined;
	        }
	        const messageAndSig = this.checkStoredSignedMessageAndSignature(this.address);
	        if (!messageAndSig) {
	            throw new Error('Could not get message and sig after login, this should not be happening');
	        }
	        // increment saveCount
	        const dialog = typeof data === 'string' ? JSON.parse(data) : data;
	        if (!dialog.saveCount) {
	            dialog.saveCount = 0;
	        }
	        const oldSaveCount = dialog.saveCount;
	        if (!this.tokenIdToSaveCount[tokenId] || dialog.saveCount > this.tokenIdToSaveCount[tokenId]) {
	            this.tokenIdToSaveCount[tokenId] = dialog.saveCount;
	        }
	        // we could technically do dialog.saveCount = ++session.saveCount,
	        // but this is easier to read and debug
	        this.tokenIdToSaveCount[tokenId] += 1;
	        dialog.saveCount = this.tokenIdToSaveCount[tokenId];
	        try {
	            // storyverse creator should handle 409 conflict to optionally retry with force
	            const response = await axios__default["default"].post(`${this.persistDraftServerPrefix}${tokenId}`, {
	                data: JSON.stringify(dialog),
	                force,
	                message: messageAndSig.message,
	                signature: messageAndSig.signature,
	            }, {
	                // allow 2xx and 3xx and 409
	                validateStatus: status => (status >= 200 && status < 400) || status === 409,
	            });
	            // if unsuccessful status, revert session saveCount
	            if (response.status < 200 || response.status >= 400) {
	                this.tokenIdToSaveCount[tokenId] = oldSaveCount;
	            }
	            return {
	                status: response.status,
	                message: response.data || undefined,
	            };
	        }
	        catch (e) {
	            // if error, revert session saveCount
	            this.tokenIdToSaveCount[tokenId] = oldSaveCount;
	            // rethrowing for client
	            throw e;
	        }
	    }
	    async authorizeChoiceCreation(payload) {
	        const response = await this.serviceSignedRequest(ServiceEndpoint.PocAuthChoiceCreation, payload);
	        log$2('authorizeChoiceCreation response:', response);
	        return response;
	    }
	    async authorizeOptionMinting(payload) {
	        const response = await this.serviceSignedRequest(ServiceEndpoint.PocAuthOptionMinting, payload);
	        log$2('authorizeOptionMinting response:', response);
	        return response;
	    }
	    async serviceSignedRequest(endpoint, data) {
	        const loggedIn = await this.logIn();
	        if (!loggedIn) {
	            log$2('serviceSignedRequest: log in failed');
	            throw new Error('serviceSignedRequest: log in failed');
	        }
	        const messageAndSig = this.checkStoredSignedMessageAndSignature(this.address);
	        if (!messageAndSig) {
	            log$2('serviceSignedRequest: Could not get message and sig after login. This should not be happening');
	            throw new Error('serviceSignedRequest: Could not get message and sig after login');
	        }
	        const response = await this.serviceAxios.post(endpoint, Object.assign({ message: messageAndSig.message, signature: messageAndSig.signature }, data));
	        return response;
	    }
	    async savePlotTitle(tokenId, title) {
	        log$2('saveTitle: ', tokenId, title);
	        if (!(await this.logIn())) {
	            log$2('saveTitle: could not save because log in failed');
	            return undefined;
	        }
	        const messageAndSig = this.checkStoredSignedMessageAndSignature(this.address);
	        if (!messageAndSig) {
	            throw new Error('Could not get message and sig after login, this should not be happening');
	        }
	        const result = await axios__default["default"].post(`${this.persistPlotServerPrefix}${tokenId}/title`, {
	            title,
	            message: messageAndSig.message,
	            signature: messageAndSig.signature
	        });
	        return result.data;
	    }
	    getStorageKeyForMessageAndSignature(address) {
	        return `messageAndSig-${address}`;
	    }
	    checkStoredSignedMessageAndSignature(address) {
	        log$2('checkStoredSignedMessageAndSignature: ', address);
	        const storageKey = this.getStorageKeyForMessageAndSignature(address);
	        const stored = localStorage.getItem(storageKey);
	        if (stored) {
	            log$2('checkStoredSignedMessageAndSignature stored:', stored);
	            try { // doing try-catch in case json parse fails
	                const parsed = JSON.parse(stored);
	                if (typeof parsed.message !== 'string') {
	                    log$2('Old message format. Invalidating.');
	                    throw new Error('Old message format detected');
	                }
	                const coreMessage = svsSignerValidator.SvsSignerValidator.getCoreMessageFromFullMessage(parsed.message);
	                const messageAndSig = {
	                    message: parsed.message,
	                    signature: parsed.signature,
	                };
	                const timestamp = coreMessage.timestamp;
	                if (timestamp && (timestamp + lib.NumberUtils.daysToMs(1)) >= (new Date().getTime() - 500)) {
	                    log$2('return stored message signing');
	                    return messageAndSig;
	                }
	                else {
	                    return undefined;
	                }
	            }
	            catch (e) {
	                localStorage.removeItem(storageKey);
	                return undefined;
	            }
	        }
	    }
	    async startGetSignedMessageAndSignature(signer) {
	        log$2('startGetSignedMessageAndSignature.1');
	        const address = await signer.getAddress();
	        const storageKey = this.getStorageKeyForMessageAndSignature(address);
	        // if stored, check timestamp, and if valid, return stored value.
	        const stored = this.checkStoredSignedMessageAndSignature(address);
	        if (stored) {
	            return stored;
	        }
	        // prompt user to sign
	        try {
	            // const messageAndSig = await MessageSigner.getSignedMessageWithSigner(address, signer)
	            const messageAndSig = await svsSignerValidator.SvsSignerValidator.getSignedMessageWithSigner(address, signer);
	            log$2('message and signature: ', messageAndSig);
	            localStorage.setItem(storageKey, JSON.stringify(messageAndSig));
	            return messageAndSig;
	        }
	        catch (e) {
	            log$2('User rejected message signing');
	            return undefined;
	        }
	    }
	    emit(event, ...args) {
	        // Overriding to emulate an "any" event
	        const emitted = super.emit(event, ...args);
	        super.emit(lib.SvsNavbarEvent.Any, event, ...args);
	        return emitted;
	    }
	    get provider() {
	        return this.providerWaiter.get();
	    }
	    get loginState() {
	        return this.loginStateWaiter.get();
	    }
	    async isWalletConnected() {
	        if (!this.provider) {
	            return false;
	        }
	        const accounts = await this.provider.listAccounts();
	        return accounts.length > 0;
	    }
	    setLoginState(loginState) {
	        if (this.loginState === loginState) {
	            return;
	        }
	        this.loginStateWaiter.set(loginState);
	        log$2('Login state', loginState);
	        this.emit(lib.SvsNavbarEvent.LoginStateChanged, loginState);
	    }
	    waitForProvider() {
	        return this.providerWaiter.wait();
	    }
	    async startLogin() {
	        await this.init();
	        const provider = await this.waitForProvider();
	        this.signer = await provider.getSigner();
	        if (this.loggedIn && this.signer) {
	            const messageAndSig = await this.startGetSignedMessageAndSignature(this.signer);
	            if (messageAndSig) {
	                log$2('Already logged in', this.address);
	                return;
	            }
	        }
	        try {
	            this.setLoginState(1 /* LoginState.LoggingIn */);
	            log$2('Requesting accounts...');
	            // this will trigger accountsChanged
	            await provider.send('eth_requestAccounts', []);
	            const messageAndSig = await this.startGetSignedMessageAndSignature(this.signer);
	            if (!messageAndSig) {
	                log$2('User rejected signing message, login aborted');
	                this.setLoginState(4 /* LoginState.LoggedOut */);
	                return;
	            }
	            else {
	                // we are checking login state here because previous eth_requestAccounts gets called before message/signature verification
	                await this.checkForLoggedIn();
	                log$2('Waiting for checked login state...');
	                await this.loginStateWaiter.wait();
	            }
	        }
	        catch (e) {
	            log$2('Error occurred while requesting eth accounts:', e);
	            this.setLoginState(4 /* LoginState.LoggedOut */);
	        }
	    }
	    async startLogout() {
	        this.signer = null;
	        this.address = null;
	        this.plots = null;
	        this.loggedInWaiter.set(false);
	        this.setLoginState(4 /* LoginState.LoggedOut */);
	        this.emit(lib.SvsNavbarEvent.WalletChanged, { loggedIn: false });
	    }
	    async logInAsSigner(signer) {
	        this.signer = signer;
	        this.address = await this.signer.getAddress();
	        this.loggedInWaiter.set(true);
	        this.setLoginState(2 /* LoginState.LoggedIn */);
	        const wallet = {
	            loggedIn: this.loggedIn,
	            address: this.address,
	            plots: this.plots,
	        };
	        this.emit(lib.SvsNavbarEvent.WalletChanged, wallet);
	    }
	    async checkForLoggedIn() {
	        const connected = await this.isWalletConnected();
	        let loggedIn = false;
	        if (connected) {
	            const signer = this.provider.getSigner();
	            if (signer) {
	                const address = await signer.getAddress();
	                const messageAndSig = await this.checkStoredSignedMessageAndSignature(address);
	                if (!messageAndSig) {
	                    await this.startLogout();
	                    log$2('checkForLoggedIn: Logged out because no valid stored messageAndSig');
	                }
	                else {
	                    loggedIn = true;
	                    await this.logInAsSigner(signer);
	                    log$2('checkForLoggedIn: Logged in');
	                }
	            }
	        }
	        else {
	            await this.startLogout();
	            log$2('checkForLoggedIn: Logged out');
	        }
	        return loggedIn;
	    }
	    async onEthChainChanged() {
	        this.providerWaiter.set(null);
	        this.inittedWaiter.set(false);
	        this.init();
	    }
	    async onEthAccountsChanged(accounts) {
	        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.length) || this.initted) {
	            this.checkForLoggedIn();
	        }
	    }
	}

	const log$1 = debug__default["default"]('svsnavbar:writerservice');
	var WritersEditorError;
	(function (WritersEditorError) {
	    // Unexpected response errors
	    WritersEditorError[WritersEditorError["FetchError"] = 1000] = "FetchError";
	    WritersEditorError[WritersEditorError["TextParsingError"] = 1001] = "TextParsingError";
	    WritersEditorError[WritersEditorError["JSONParsingError"] = 1002] = "JSONParsingError";
	    WritersEditorError[WritersEditorError["MissingErrorStatus"] = 1003] = "MissingErrorStatus";
	    WritersEditorError[WritersEditorError["InvalidErrorStatus"] = 1004] = "InvalidErrorStatus";
	    WritersEditorError[WritersEditorError["MissingErrorBody"] = 1005] = "MissingErrorBody";
	    WritersEditorError[WritersEditorError["InvalidErrorBody"] = 1006] = "InvalidErrorBody";
	    WritersEditorError[WritersEditorError["MissingBody"] = 1007] = "MissingBody";
	    WritersEditorError[WritersEditorError["MissingPlainText"] = 1008] = "MissingPlainText";
	    // API response errors
	    WritersEditorError[WritersEditorError["MissingOwnerEditors"] = 2000] = "MissingOwnerEditors";
	})(WritersEditorError || (WritersEditorError = {}));
	var FetchMethod;
	(function (FetchMethod) {
	    FetchMethod["GET"] = "GET";
	    FetchMethod["POST"] = "POST";
	})(FetchMethod || (FetchMethod = {}));
	var BCUrlPath;
	(function (BCUrlPath) {
	    BCUrlPath["AddEditor"] = "/ca/addEditor";
	    BCUrlPath["RemoveEditor"] = "/ca/removeEditor";
	    BCUrlPath["ListEditors"] = "/ca/findOwnerEditors";
	    BCUrlPath["OwnerOf"] = "/m/storyverse_plot/methods/ownerOf";
	})(BCUrlPath || (BCUrlPath = {}));
	var BCParam;
	(function (BCParam) {
	    BCParam["TokenId"] = "tokenId";
	    BCParam["Editor"] = "editor";
	})(BCParam || (BCParam = {}));
	function isWalletReady(wallet) {
	    if (!wallet) {
	        return false;
	    }
	    if (!wallet.loggedIn) {
	        return false;
	    }
	    if (!wallet.messageAndSig) {
	        return false;
	    }
	    if (!wallet.messageAndSig.message || !wallet.messageAndSig.signature) {
	        return false;
	    }
	    return true;
	}
	class WriterService {
	    init(config, walletService) {
	        this.config = config;
	        this.walletService = walletService;
	    }
	    async addWriter(tokenId, address, skipList) {
	        const editRequest = {
	            [BCParam.TokenId]: tokenId,
	            [BCParam.Editor]: address,
	        };
	        const result = await this.apiFetch(FetchMethod.POST, BCUrlPath.AddEditor, {
	            body: editRequest,
	            withSig: true,
	            plainTextResponse: true,
	        });
	        log$1('addWriter', result);
	        if (skipList) {
	            return null;
	        }
	        return await this.fetchWriters(tokenId);
	    }
	    async removeWriter(tokenId, address, skipList) {
	        const editRequest = {
	            [BCParam.TokenId]: tokenId,
	            [BCParam.Editor]: address,
	        };
	        const result = await this.apiFetch(FetchMethod.POST, BCUrlPath.RemoveEditor, {
	            body: editRequest,
	            withSig: true,
	            plainTextResponse: true,
	        });
	        log$1('removeWriter', result);
	        if (skipList) {
	            return null;
	        }
	        return await this.fetchWriters(tokenId);
	    }
	    async fetchWriters(plotId) {
	        var _a;
	        const params = new URLSearchParams({
	            [BCParam.TokenId]: plotId,
	        });
	        const result = await this.apiFetch(FetchMethod.GET, BCUrlPath.ListEditors, { params });
	        if (!result.ownerEditors) {
	            const errorCode = WritersEditorError.MissingOwnerEditors;
	            log$1('Error in fetching writers:', errorCode);
	            throw new Error(`Unexpected writers error (code: ${errorCode})`);
	        }
	        const owner = (_a = result.ownerEditors[0]) === null || _a === void 0 ? void 0 : _a.owner_address;
	        // map to writers format
	        const writers = result.ownerEditors
	            .map((ownerEditor) => {
	            if (!ownerEditor.editor_address) {
	                log$1('fetchWriters: Missing editor_address');
	                return null;
	            }
	            return ownerEditor.editor_address;
	        })
	            // filter out empty/null
	            .filter((writer) => !!writer)
	            .map(writer => ({ address: writer }));
	        return { owner, writers };
	    }
	    async isCurrentOwner(tokenId) {
	        const loggedIn = await this.walletService.logIn();
	        if (!loggedIn) {
	            throw new Error('Not logged in');
	        }
	        const wallet = await this.walletService.getWallet();
	        if (!isWalletReady(wallet)) {
	            throw new Error('Wallet not properly connected.');
	        }
	        const params = new URLSearchParams();
	        params.append(BCParam.TokenId, tokenId);
	        const plotOwner = await this.apiFetch(FetchMethod.GET, BCUrlPath.OwnerOf, {
	            params,
	            plainTextResponse: true,
	            retryAttempts: 3,
	        });
	        return plotOwner.toLowerCase() === wallet.address.toLowerCase();
	    }
	    async apiFetch(method, path, options) {
	        const { params, body, withSig = false, plainTextResponse = false, retryAttempts = 0, retryDelay = 2000, } = Object.assign({}, options);
	        // get wallet if applicable
	        let wallet = null;
	        if (withSig) {
	            const loggedIn = this.walletService.logIn();
	            if (!loggedIn) {
	                throw new Error('Not logged in');
	            }
	            wallet = await this.walletService.getWallet();
	            if (!isWalletReady(wallet)) {
	                throw new Error('Wallet not properly connected.');
	            }
	        }
	        // build URL
	        const urlObj = new URL(this.config.serviceProxyUrl + path);
	        params === null || params === void 0 ? void 0 : params.forEach((value, key) => urlObj.searchParams.append(key, value));
	        const url = urlObj.toString();
	        // optional request body
	        let requestBody = null;
	        if (body || withSig) {
	            requestBody = {};
	        }
	        if (withSig) {
	            requestBody.signature = wallet.messageAndSig.signature;
	            requestBody.message = wallet.messageAndSig.message;
	        }
	        if (body) {
	            requestBody = Object.assign(Object.assign({}, requestBody), body);
	        }
	        // send fetch
	        let response;
	        for (let tries = 0; tries <= retryAttempts && !(response === null || response === void 0 ? void 0 : response.ok); tries += 1) {
	            try {
	                const request = { method };
	                if (requestBody) {
	                    request.body = JSON.stringify(requestBody);
	                    request.headers = {
	                        'Content-Type': 'application/json',
	                    };
	                }
	                response = await fetch(url, request);
	            }
	            catch (e) {
	                console.error('Error while editing writers:', e);
	                if (tries >= retryAttempts) {
	                    throw new Error(`Unexpected writers error (${WritersEditorError.FetchError})`);
	                }
	                else {
	                    await waitForMs_1(retryDelay);
	                }
	            }
	        }
	        // parse plaintext
	        if (plainTextResponse) {
	            // typing shenanigans
	            return (await this.parsePlainText(response));
	        }
	        // parse body with error parsing
	        const responseBody = await this.parseBody(response);
	        return responseBody;
	    }
	    async parsePlainText(result) {
	        let text;
	        try {
	            text = await result.text();
	        }
	        catch (e) {
	            console.error('Error in editing writers while parsing plaintext:', e);
	            throw new Error(`Unexpected writers error (code: ${WritersEditorError.TextParsingError})`);
	        }
	        if (!(text === null || text === void 0 ? void 0 : text.length)) {
	            const errorCode = WritersEditorError.MissingPlainText;
	            console.error('Error in editing writers:', errorCode);
	            throw new Error(`Unexpected writers error (code: ${errorCode})`);
	        }
	        return text;
	    }
	    async parseBody(result) {
	        let plainText;
	        let data;
	        try {
	            plainText = await result.text();
	        }
	        catch (e) {
	            console.error('Error in editing writers while parsing plaintext:', e);
	            throw new Error(`Unexpected writers error (code: ${WritersEditorError.TextParsingError})`);
	        }
	        try {
	            data = JSON.parse(plainText);
	        }
	        catch (e) {
	            // maybe error message is in plain text
	            if (!result.ok) {
	                console.error('Error in editing writers:', result.status, plainText);
	                throw new Error(`Error: ${plainText}`);
	            }
	            // success response needs to be JSON, so throw an error
	            const errorCode = WritersEditorError.JSONParsingError;
	            console.error('Error in editing writers:', errorCode, e);
	            throw new Error(`Unexpected writers error (code: ${errorCode})`);
	        }
	        if (!('statusCode' in data)) {
	            const errorCode = WritersEditorError.MissingErrorStatus;
	            console.error('Error in editing writers:', errorCode);
	            throw new Error(`Unexpected writers error (code: ${errorCode})`);
	        }
	        if (typeof data.statusCode !== 'number') {
	            const errorCode = WritersEditorError.InvalidErrorStatus;
	            console.error('Error in editing writers:', errorCode);
	            throw new Error(`Unexpected writers error (code: ${errorCode})`);
	        }
	        // we care about the data status code
	        const statusCode = data.statusCode;
	        if (statusCode < 200 || statusCode >= 300) {
	            // treat as error
	            if (!data.body) {
	                const errorCode = WritersEditorError.MissingErrorBody;
	                console.error('Error in editing writers:', errorCode);
	                throw new Error(`Unexpected writers error (code: ${errorCode})`);
	            }
	            if (typeof data.body !== 'string') {
	                const errorCode = WritersEditorError.InvalidErrorBody;
	                console.error('Error in editing writers:', errorCode);
	                throw new Error(`Unexpected writers error (code: ${errorCode})`);
	            }
	            console.error('Error from API:', data.statusCode, data.body);
	            throw new Error(data.body);
	        }
	        if (!('body' in data)) {
	            const errorCode = WritersEditorError.MissingBody;
	            console.error('Error in editing writers:', errorCode);
	            throw new Error(`Unexpected writers error (code: ${errorCode})`);
	        }
	        return data.body;
	    }
	}

	const log = debug__default["default"]('svsnavbar:bridge');
	const walletService = new MetaMaskWalletService();
	const writerService = new WriterService();
	class SvsBridge extends EventEmitter.EventEmitter {
	    constructor(opts) {
	        super();
	        walletService.init(opts);
	        walletService.on(lib.SvsNavbarEvent.Any, this.onAny, this);
	        writerService.init(opts, walletService);
	    }
	    async isWeb3Capable() {
	        const provider = await detectEthereumProvider__default["default"]();
	        return Boolean(provider);
	    }
	    async connect(iframe) {
	        if (this.connection) {
	            await this.disconnect();
	        }
	        this.iframe = iframe;
	        log('Creating connection...');
	        this.connection = penpal.connectToChild({
	            iframe,
	            methods: this.createMethods(),
	        });
	        log('Waiting for connection...');
	        this.client = await this.connection.promise;
	        log('Connection established.');
	        return this;
	    }
	    async disconnect() {
	        if (!this.connection) {
	            return this;
	        }
	        this.iframe = null;
	        this.client = null;
	        this.connection.destroy();
	        this.connection = null;
	        log('Connection destroyed.');
	        return this;
	    }
	    emit(event, ...args) {
	        // Overriding to emulate an "any" event
	        const emitted = super.emit(event, ...args);
	        super.emit(lib.SvsNavbarEvent.Any, event, ...args);
	        return emitted;
	    }
	    on(event, fn, context) {
	        return super.on(event, fn, context);
	    }
	    once(event, fn, context) {
	        return super.once(event, fn, context);
	    }
	    off(event, fn, context) {
	        return super.off(event, fn, context);
	    }
	    createMethods() {
	        return {
	            getWallet: walletService.getWallet.bind(walletService),
	            logIn: walletService.logIn.bind(walletService),
	            isLoggedIn: () => Promise.resolve(walletService.loggedIn),
	            saveDraft: walletService.saveDraft.bind(walletService),
	            authorizeChoiceCreation: walletService.authorizeChoiceCreation.bind(walletService),
	            authorizeOptionMinting: walletService.authorizeOptionMinting.bind(walletService),
	            onClientEvent: this.onClientEvent.bind(this),
	            // safer to do bind individual functions
	            writers: {
	                addWriter: writerService.addWriter.bind(writerService),
	                removeWriter: writerService.removeWriter.bind(writerService),
	                fetchWriters: writerService.fetchWriters.bind(writerService),
	                isCurrentOwner: writerService.isCurrentOwner.bind(writerService),
	            },
	            savePlotTitle: walletService.savePlotTitle.bind(walletService)
	        };
	    }
	    onAny(event, ...args) {
	        if (!this.client || !this.client.onNavbarEvent) {
	            return;
	        }
	        this.client.onNavbarEvent(event, ...args);
	    }
	    onClientEvent(event, ...args) {
	        this.emit(event, ...args);
	    }
	}

	exports.SvsBridge = SvsBridge;
	exports.SvsNavbarEvent = lib.SvsNavbarEvent;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
